import { render, staticRenderFns } from "./Frota.vue?vue&type=template&id=53b8a6d8"
import script from "./Frota.vue?vue&type=script&lang=js"
export * from "./Frota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports